import React from 'react'
import './facebok.scss'

const Facebok = () => {
    return (
        <div className='p-sec-4-cont'>
            <div className='p-sec-6-inn'>
                <h2>Our Social Feed</h2>
                <h3>Like Us on facebook and keep Connected</h3>
                <iframe src="https://widgets.sociablekit.com/facebook-page-posts/iframe/25682534" frameborder="0" width="100%" height="1000px"></iframe>
            </div>
        </div>
    )
}

export default Facebok;